import { Spin } from 'antd';

import './PageLoader.scss';

export const PageLoader = (): JSX.Element => {
    return (
        <div className="page-loader">
            <Spin size="large" />
        </div>
    );
};
